/*
	ReactTemplates compatibility shim (WEB-7832).

	window.ReactTemplates is a global aggregator of shared React components/helpers, historically
	created and populated from inside the Angular tree (ui/app/upsales/common/components/react/,
	pulled into the bundle by ui/app/babel/legacy-react.js). ~77 of its keys are read by code
	outside the Angular tree, so the global must survive the Phase 6 deletion of ui/app/upsales/.

	This module owns the global's creation, mirroring the ToolsShim strategy:
	1. installReactTemplatesShim() runs at the React entry, before legacy-react.js loads the
	   Angular tree. It creates the global and its namespaces.
	2. The Angular tree's writers (index.jsx and friends) merge their keys into the existing
	   global instead of replacing it.
	3. As components move out of the Angular tree (batch by batch, one namespace at a time),
	   this module imports and registers them — the old tree path keeps a one-line re-export
	   stub so intra-tree imports keep working until Phase 6 deletes the tree wholesale.
	4. When every key read outside the tree is registered from here, the app no longer depends
	   on the Angular tree for the global.

	Calling install() more than once, or after the Angular tree has already populated the global
	(as in the jest smoketest harness), is safe: existing namespaces and keys are kept.
*/
// The legacy aggregator (WEB-8019): self-creates the global's namespaces and registers ~20
// TOOLS.* helpers + ROW.formRow at module scope. Evaluating it here (at the React entry) is
// safe — its module scope reads no Tools/window state — and earlier than the old
// legacy-react.js position, which only tree files relied on. It has to stay a side-effect import:
// everything below assumes the global and its namespaces already exist.
// WEB-9232 retired the TOOLS namespace, so install() no longer re-assigns any TOOLS key — every
// consumer imports the helper it needs directly. ui/app/upsales/** still reads ~16 of them off the
// global, and the aggregator's own module-eval registrations above cover those.
import 'App/babel/components/LegacyReactTemplates';
import FormRow from 'App/babel/components/LegacyReactTemplates/listForms';
import UpSelect from 'Components/Inputs/UpSelect';
import UpAudio from 'Components/Inputs/UpAudio';
import upUsers from 'App/babel/components/Inputs/LegacyInputs/upUsers';
import upStages from 'App/babel/components/Inputs/LegacyInputs/upStages';
import upCampaigns from 'App/babel/components/Inputs/LegacyInputs/upCampaigns';
import upOptins from 'App/babel/components/Inputs/LegacyInputs/upOptins';
import upCategories from 'App/babel/components/Inputs/LegacyInputs/upCategories';
import upOpportunities from 'App/babel/components/Inputs/LegacyInputs/upOpportunities';
import upRoles from 'App/babel/components/Inputs/LegacyInputs/upRoles';
import upContacts from 'App/babel/components/Inputs/LegacyInputs/upContacts';
import upAccounts, { upAccountsIds } from 'App/babel/components/Inputs/LegacyInputs/upAccounts';
import upProducts from 'App/babel/components/Inputs/LegacyInputs/upProducts';
import upTags from 'App/babel/components/Inputs/LegacyInputs/upTags';
import datepicker from 'App/babel/components/Inputs/LegacyInputs/datepicker';
import customFieldInput from 'App/babel/components/Inputs/LegacyInputs/customField';
// The legacy upFilters engine (WEB-8020): upListFilters + filters/*.jsx self-register onto
// window.ReactTemplates.upFilters at module eval. Side-effect import runs AFTER the aggregator
// import above (which creates window.ReactTemplates), so the namespace exists when it evals.
import 'App/babel/components/LegacyFilters';
// upToggle (WEB-8859): registers ReactTemplates.checkbox AND assigns into
// ReactTemplates.upFilters.components.toggle at module scope. That assignment reads the
// upFilters.components object LegacyFilters creates, so this import MUST stay after it —
// reversed, the assignment throws on undefined.
import 'App/babel/components/LegacyReactTemplates/upToggle';
// The legacy mailCampaign subtree (WEB-8483): root.jsx + components/pages self-register onto
// window.ReactTemplates.mailCampaign at module eval. Same side-effect-import pattern as upFilters.
import 'App/babel/components/LegacyMailCampaign';
// The legacy findProspects subtree (WEB-8484): root.jsx + sidebar/filters self-register onto
// window.ReactTemplates.findProspect at module eval. Same side-effect-import pattern as above.
import 'App/babel/components/LegacyFindProspects';
// The legacy segment subtree (WEB-8485): root.jsx + body/flow/modals self-register onto
// window.ReactTemplates.segment at module eval. Same side-effect-import pattern as above.
import 'App/babel/components/LegacySegment';
// The legacy form / landing-page subtree (WEB-8486): editLandingpageRoot.jsx + the content-type
// files self-register onto window.ReactTemplates.form at module eval. Same side-effect pattern.
import 'App/babel/components/LegacyForm';
// The legacy admin subtree (WEB-8048): root.jsx + pages/components self-register onto
// window.ReactTemplates.admin at module eval. 26 of the keys are now imported directly by their
// single consumer, but several subtree files still reach siblings through the global, so the whole
// barrel loads and the namespace stays populated.
import 'App/babel/components/LegacyAdmin';
// elevio (WEB-8858): a single presentational component that self-registers
// window.ReactTemplates.elevio at module eval. 164 readers outside the Angular tree.
import 'App/babel/components/LegacyReactTemplates/elevio';
// customFieldInput (WEB-8860): the widget behind every custom-field input; self-registers
// window.ReactTemplates.customFieldInput at module eval.
import 'App/babel/components/LegacyReactTemplates/customFieldInput';
// The last externally-read leaves (WEB-8861). upCurrencies/multiInputRange assign into
// ReactTemplates.INPUTS, which the LegacyReactTemplates aggregator creates at module eval
// above, so INPUTS already exists by the time these run.
import 'App/babel/components/LegacyReactTemplates/oldLoader';
import 'App/babel/components/LegacyReactTemplates/upStepInt';
import 'App/babel/components/LegacyReactTemplates/esignAppPlaceholder';
import 'App/babel/components/LegacyReactTemplates/upCurrencies';
import 'App/babel/components/LegacyReactTemplates/multiInputRange';
import 'App/babel/components/LegacyReactTemplates/processedBy';
// The row registrations (WEB-8988). These assign into ReactTemplates.ROW / ROWSTATICS, which the
// LegacyReactTemplates aggregator creates at module eval above — so the namespaces already exist.
import 'App/babel/components/LegacyReactTemplates/listContacts';
import 'App/babel/components/LegacyReactTemplates/listVisitors';

// Capture the populated namespaces so a re-install after global replacement (the
// mixed-jest-harness case) restores them — the side-effect imports only run once.
const legacyGlobal = (
	window as unknown as {
		ReactTemplates?: {
			upFilters?: unknown;
			mailCampaign?: unknown;
			findProspect?: unknown;
			segment?: unknown;
			form?: unknown;
			admin?: unknown;
			elevio?: unknown;
			checkbox?: unknown;
			customFieldInput?: unknown;
			loader?: unknown;
			upStepInt?: unknown;
			esignAppPlaceholder?: unknown;
			processedByColumn?: unknown;
			INPUTS?: Record<string, unknown>;
			ROW?: Record<string, unknown>;
			ROWSTATICS?: Record<string, unknown>;
		};
	}
).ReactTemplates;
const legacyUpFilters = legacyGlobal?.upFilters;
const legacyMailCampaign = legacyGlobal?.mailCampaign;
const legacyFindProspect = legacyGlobal?.findProspect;
const legacySegment = legacyGlobal?.segment;
const legacyForm = legacyGlobal?.form;
const legacyAdmin = legacyGlobal?.admin;
const legacyElevio = legacyGlobal?.elevio;
const legacyCheckbox = legacyGlobal?.checkbox;
const legacyCustomFieldInput = legacyGlobal?.customFieldInput;
const legacyLoader = legacyGlobal?.loader;
const legacyUpStepInt = legacyGlobal?.upStepInt;
const legacyEsignAppPlaceholder = legacyGlobal?.esignAppPlaceholder;
const legacyProcessedByColumn = legacyGlobal?.processedByColumn;
// These two live under INPUTS rather than at the top level, so they need capturing by sub-key:
// install() sets the other INPUTS entries explicitly, but not these.
const legacyUpCurrency = legacyGlobal?.INPUTS?.upCurrency;
const legacyMultiRangeInput = legacyGlobal?.INPUTS?.multiRangeInput;
// Same sub-key problem as the INPUTS pair above: install() sets ROW.formRow explicitly but not
// these, so they need capturing individually (WEB-8988).
const legacyRowKeys: [string, unknown][] = [
	['contactRow', legacyGlobal?.ROW?.contactRow],
	['SegmentInfoRow', legacyGlobal?.ROW?.SegmentInfoRow],
	['visitorRow', legacyGlobal?.ROW?.visitorRow]
];
const legacyRowStaticsKeys: [string, unknown][] = [
	['contactRow', legacyGlobal?.ROWSTATICS?.contactRow],
	['visitorRow', legacyGlobal?.ROWSTATICS?.visitorRow]
];

// TOOLS is still listed even though WEB-9232 removed every key registration: ui/app/upsales/**
// reads ~16 TOOLS keys off the global, and creating the namespace here (as well as in the
// aggregator's module eval) keeps a re-install after something replaced the global from leaving
// the tree with no namespace to read. It goes when Phase 6 deletes the tree.
const NAMESPACES = ['TOOLS', 'ROW', 'ROWSTATICS', 'OTHER', 'INPUTS', 'MODALS', 'navbar'] as const;

const installReactTemplatesShim = () => {
	// The full ReactTemplates type describes the populated end state; population is incremental
	// by design, so the skeleton is built through an untyped alias.
	const w = window as unknown as { ReactTemplates: Record<string, Record<string, unknown>> };
	w.ReactTemplates = w.ReactTemplates || {};
	for (const ns of NAMESPACES) {
		w.ReactTemplates[ns] = w.ReactTemplates[ns] || {};
	}
	w.ReactTemplates.navbar.searchRows = w.ReactTemplates.navbar.searchRows || {};

	// upFilters (WEB-8020): restore the captured, fully-populated namespace (filterMenu +
	// components + filterTypes) — survives Phase 6 and re-installs after global replacement.
	if (legacyUpFilters) {
		w.ReactTemplates.upFilters = legacyUpFilters as Record<string, unknown>;
	}
	// mailCampaign (WEB-8483): restore the captured subtree namespace (root + sidebar + pages/...).
	if (legacyMailCampaign) {
		w.ReactTemplates.mailCampaign = legacyMailCampaign as Record<string, unknown>;
	}
	// findProspect (WEB-8484): restore the captured subtree namespace (root + sidebar + filters).
	if (legacyFindProspect) {
		w.ReactTemplates.findProspect = legacyFindProspect as Record<string, unknown>;
	}
	// segment (WEB-8485): restore the captured subtree namespace (root + body + flow* + modals).
	if (legacySegment) {
		w.ReactTemplates.segment = legacySegment as Record<string, unknown>;
	}
	// form (WEB-8486): restore the captured subtree namespace (editLandingpageRoot + content types
	// + validDomainModal/domainRow).
	if (legacyForm) {
		w.ReactTemplates.form = legacyForm as Record<string, unknown>;
	}
	// admin (WEB-8048): restore the captured subtree namespace (root + sidebar + pages/components).
	if (legacyAdmin) {
		w.ReactTemplates.admin = legacyAdmin as Record<string, unknown>;
	}
	// elevio (WEB-8858): a single component, not a namespace — restore it directly.
	if (legacyElevio) {
		(w.ReactTemplates as Record<string, unknown>).elevio = legacyElevio;
	}
	// checkbox (WEB-8859): likewise a single component. Its sibling key,
	// upFilters.components.toggle, rides along with the restored upFilters namespace above.
	if (legacyCheckbox) {
		(w.ReactTemplates as Record<string, unknown>).checkbox = legacyCheckbox;
	}
	// customFieldInput (WEB-8860): another single component restored as a plain key.
	if (legacyCustomFieldInput) {
		(w.ReactTemplates as Record<string, unknown>).customFieldInput = legacyCustomFieldInput;
	}
	// The last leaves (WEB-8861), all single components restored as plain keys. upCurrency and
	// multiRangeInput ride along with the INPUTS namespace.
	const leaves: [string, unknown][] = [
		['loader', legacyLoader],
		['upStepInt', legacyUpStepInt],
		['esignAppPlaceholder', legacyEsignAppPlaceholder],
		['processedByColumn', legacyProcessedByColumn]
	];
	for (const [key, value] of leaves) {
		if (value) {
			(w.ReactTemplates as Record<string, unknown>)[key] = value;
		}
	}
	if (legacyUpCurrency) {
		w.ReactTemplates.INPUTS.upCurrency = legacyUpCurrency;
	}
	if (legacyMultiRangeInput) {
		w.ReactTemplates.INPUTS.multiRangeInput = legacyMultiRangeInput;
	}
	for (const [key, value] of legacyRowKeys) {
		if (value) {
			w.ReactTemplates.ROW[key] = value;
		}
	}
	for (const [key, value] of legacyRowStaticsKeys) {
		if (value) {
			w.ReactTemplates.ROWSTATICS[key] = value;
		}
	}

	// INPUTS (WEB-8018). upSelect's source always lived outside the tree — the tree file was
	// 5 lines of glue, now deleted. upAudio had NO tree writer at all: the read in
	// EditActivity/BaseInfo.js rendered undefined whenever a phone call had a recording —
	// registering the real component fixes that latent crash.
	w.ReactTemplates.INPUTS.upSelect = UpSelect;
	w.ReactTemplates.INPUTS.upAudio = UpAudio;
	w.ReactTemplates.INPUTS.upUsers = upUsers;
	w.ReactTemplates.INPUTS.upStages = upStages;
	w.ReactTemplates.INPUTS.upCampaigns = upCampaigns;
	w.ReactTemplates.INPUTS.upOptins = upOptins;
	w.ReactTemplates.INPUTS.upCategories = upCategories;
	w.ReactTemplates.INPUTS.upOpportunities = upOpportunities;
	w.ReactTemplates.INPUTS.upRoles = upRoles;
	w.ReactTemplates.INPUTS.upContacts = upContacts;
	w.ReactTemplates.INPUTS.upAccounts = upAccounts;
	w.ReactTemplates.INPUTS.upAccountsIds = upAccountsIds;
	w.ReactTemplates.ROW.formRow = FormRow;
	w.ReactTemplates.INPUTS.upProducts = upProducts;
	w.ReactTemplates.INPUTS.upTags = upTags;
	w.ReactTemplates.INPUTS.datepicker = datepicker;
	w.ReactTemplates.INPUTS.customFieldInput = customFieldInput;
};

export default installReactTemplatesShim;
